<script>
import ModalDialog from '../../UI/Modal/ModalDialog.vue'
import FormCreator from '../../UI/Form/FormCreator.vue'
import FieldCreator from '../../UI/Form/FieldCreator.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    simulation: { type: Object, default: {} },
    simulationId: { type: Number, default: '' },
    rent: { type: Object, default: {} },
    def: { type: Object, default: {} },
    isVisible: { type: Boolean, default: false },
  },

  data: () => ({
    addDirector: false,
    noTitle: false,
    directorId: null,
    formData: null,
  }),

  watch: {
    isVisible: {
      handler() {
        this.$refs.modalRequest.open()
      },
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ loading, build, object, def }) {
      this.directorId = object.director ? object.director.id : null
    },
    async sendRequest() {
      this.$refs.requestField.datas['finance'] = {
        duration: this.rent.duration,
      }

      this.$refs.requestField.methods('patch')
    },
    setDatas({ sending, context }) {
      if (context === 'patch' && sending === false) {
        this.closeModal()
        const currentUrl = new URL(window.location.href)
        const targetUrl = new URL(window.location.href)

        if (
          (this.simulation.refinancerStatus == 'REFUSED' || this.simulation.refinancerStatus == 'NOT_ACCEPTED') &&
          this.hasRole('ROLE_DETAILLED_STUDY')
        ) {
          targetUrl.searchParams.set('index', 'simulation')
          targetUrl.searchParams.set('p', 'demand')
        } else {
          targetUrl.searchParams.set('index', 'simulation')
          targetUrl.searchParams.set('p', 'devis')
        }

        if (targetUrl.href === currentUrl.href) {
          window.location.reload()
        } else {
          window.location.href = targetUrl.toString()
        }
      }
    },
    closeModal() {
      this.$refs.modalRequest.close(false)
    },
  },
}
</script>
<template>
  <ModalDialog
    id="modal-request"
    ref="modalRequest"
    id-modal-page="proposalbox"
    class-modal-dialog="modal-lg"
    title-t="simulation.popin.request.title"
    e2e-modal="request"
  >
    <template #body>
      <h5 v-if="!noTitle" class="text-center mt-3">{{ $t('simulation.popin.request.message') }}</h5>
      <FormCreator
        @update-data="updateData"
        ref="requestField"
        src-error="requestField"
        :id="simulationId"
        endpoint="quotations"
        :config-def="def"
        :config-object="simulation"
        specific-endpoint="request"
        dynamic
        class-to-add="d-none"
        @object-return="setDatas"
      ></FormCreator>
      <div class="text-center" v-if="formData">
        <FieldCreator
          :form-data="formData"
          name="equipment.brand"
          form-ref="requestField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="equipment.model"
          form-ref="requestField"
          domain="simulation"
          :label-top="true"
        ></FieldCreator>
        <FieldCreator
          :form-data="formData"
          name="director"
          form-ref="requestField"
          domain="simulation"
          :add-director="true"
          :slot-add="true"
          :director-id="directorId"
          :finance-id="simulation.finance.id"
          :entity-id="simulation.client.id"
          :label-top="true"
        ></FieldCreator>
      </div>
    </template>
    <template #footer>
      <ButtonAll margin="no" type="information" data-dismiss="modal" label="button.cancel"></ButtonAll>
      <ButtonAll margin="no" type="validation" @click="sendRequest" label="simulation.popin.request.send"></ButtonAll>
    </template>
  </ModalDialog>
</template>
